import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

import { useGetDenounceVectorFocusReport } from '../../hooks/useDashboardService';
import { useGetWorkingAreasSelector } from '../../hooks/useWorkingAreasService';

import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import SimpleAgentUserCard from '../../components/SimpleAgentUserCard/SimpleAgentUserCard';
import YourWorkingAreaCard from '../../components/YourWorkingAreaCard/YourWorkingAreaCard';
import AgentStatsCard from '../../components/AgentStatsCard/AgentStatsCard';
import CityMonitoringCTA from '../../components/CityMonitoringCTA/CityMonitoringCTA';

import stringUtils from '../../utils/StringUtils';
import settings from '../../settings/settings';

import './Home.scss';

function Home() {
  const navigate = useNavigate();
  const { authUser, isAuthorized } = useContext(AuthContext);
  const {
    totalNumDenounces,
    totalNumOpenedDenounces,
    totalNumInProgresDenounces,
    totalNumFinishedDenounces,
    totalNumFocus,
    totalNumOpenedFocus,
    totalNumInProgresFocus,
    totalNumFinishedFocus
  } = useGetDenounceVectorFocusReport({
    userId: authUser?.user?.id,
    agentId: authUser?.roles?.agent?.id
  });
  const [, , agentWorkingArea] = useGetWorkingAreasSelector({
    cityId: authUser?.roles?.agent?.city?.id,
    agentId: authUser?.roles?.agent?.id
  });
  const cityName = authUser?.roles?.agent?.city?.name;
  const managerName = authUser?.roles?.agent?.manager?.platform_user?.user?.first_name;
  const managerImageURL = authUser?.roles?.agent?.manager?.platform_user?.user?.profile_picture?.url;
  const agentFirstName = authUser?.user?.first_name;
  const agentName = stringUtils.getFullName({
    firstName: agentFirstName,
    lastName: authUser?.user?.last_name
  });
  const agentImageURL = authUser?.user?.profile_picture?.url || authUser?.user?.profile_picture;
  const agentAreaId = agentWorkingArea?.id;
  const agentAreaDescription = agentWorkingArea?.description;
  const placeholderMapImageUrl = 'images/img-default-map-snapshot.png';
  const workingAreaMessageToAgent = `Oi ${agentFirstName}, esta é sua área de trabalho`;
  const logoURL = `${settings.BASE_PATH_IMAGES_FOLDER}/logo-vc-agente-web.svg`;

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  function handleGoToMonitoringPage() {
    navigate('/monitoring');
  }

  function handleGoToWorkingAreaDetails(workingAreaId) {
    navigate('/working-area', {
      state: {
        workingAreaId
      }
    });
  }

  function handleNavigateToDenounces() {
    navigate('/denounces');
  }

  function handleNavigateToVectorFoci() {
    navigate('/vector-foci');
  }

  return (
    <div className="inner-page home-page">
      <Header
        pageTitleIconURL={logoURL}
      />
      <div className="inner-page-content-container">
        <SimpleAgentUserCard
          className="agent-info"
          agentImageURL={agentImageURL}
          agentName={agentName}
          cityName={cityName}
        />
        <YourWorkingAreaCard
          className="agent-working-area"
          managerImageURL={managerImageURL}
          managerName={managerName}
          workingAreaMessageToAgent={workingAreaMessageToAgent}
          agentAreaId={agentAreaId}
          agentAreaDescription={agentAreaDescription}
          handleGoToWorkingAreaDetails={handleGoToWorkingAreaDetails}
        />
        <AgentStatsCard
          className="agent-denounces-vector-foci"
          totalNumDenounces={totalNumDenounces}
          totalNumOpenedDenounces={totalNumOpenedDenounces}
          totalNumInProgresDenounces={totalNumInProgresDenounces}
          totalNumFinishedDenounces={totalNumFinishedDenounces}
          totalNumFocus={totalNumFocus}
          totalNumOpenedFocus={totalNumOpenedFocus}
          totalNumInProgresFocus={totalNumInProgresFocus}
          totalNumFinishedFocus={totalNumFinishedFocus}
          handleNavigateToDenounces={handleNavigateToDenounces}
          handleNavigateToVectorFoci={handleNavigateToVectorFoci}
        />
        <CityMonitoringCTA
          className="monitoring-cta"
          placeholderMapImageUrl={placeholderMapImageUrl}
          handleGoToMonitoringPage={handleGoToMonitoringPage}
        />
      </div>
      <BottomMenu />
    </div>
  );
}

export default Home;
